import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import {AuthProvider} from './services/AuthProvider';
import {ErrorProvider, useError} from "./services/ErrorContext";
import SnackbarAlertMessage from "./components/Modal/SnackbarAlertMessage";

const ErrorNotification: React.FC = () => {
  const { error, setError } = useError();

  return (
    <SnackbarAlertMessage
      open={!!error}
      severity="error"
      message={error || ''}
      onClose={() => setError(null)}
    />
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
        <ErrorNotification />
      </ErrorProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
